import { ApolloProvider } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import { ConfigProvider } from "antd";
import type { Locale } from "antd/es/locale-provider";
import en_GB from "antd/es/locale/en_GB";
import fr_FR from "antd/es/locale/fr_FR";
import i18n from "config/i18n/i18n";
import { routers } from "config/routes";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import minMax from "dayjs/plugin/minMax";
import utc from "dayjs/plugin/utc";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";

import "@neonumy/neonumy-ui/lib/index.css";
import "resources/styles/main.less";

const CONFIG_TRANSLATIONS: Record<string, Locale> = {
  fr: fr_FR,
  en: en_GB,
};

dayjs.locale(i18n.language);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(minMax);

export default function App() {
  return (
    <ApolloProvider client={clientNeoAuth}>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider locale={CONFIG_TRANSLATIONS[i18n.language]}>
          <RouterProvider router={routers} />
        </ConfigProvider>
      </I18nextProvider>
    </ApolloProvider>
  );
}
